// src/components/Blog.js
import React, { useState } from 'react';
import './Blog.css';

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Revenue Cycle', 'Denial Management', 'Coding', 'Billing Guidelines', 'KPIs', 'Outsourcing'];

  const blogPosts = [
    {
      id: 1,
      title: 'How do Player Policy Changes Affect Your Revenue?',
      excerpt: 'Healthcare providers in the United States are in a constantly transforming environment. And one of the biggest challenges...',
      category: 'Revenue Cycle',
      readTime: '5 min read',
      date: 'Mar 15, 2025',
      image: null
    },
    {
      id: 2,
      title: 'CO 50 Denial Code Descriptions, Causes, Prevention & Solution',
      excerpt: 'If you didn\'t know, medical necessity denials are one of the leading causes of revenue loss for healthcare providers...',
      category: 'Denial Management',
      readTime: '7 min read',
      date: 'Mar 12, 2025',
      image: null
    },
    {
      id: 3,
      title: 'ICD-10 Code F43.10: PTSD Billing Guide 2025',
      excerpt: 'ICD-10 code F43.10 PTSD, unspecified is one of the most used and most misused mental health diagnostic codes...',
      category: 'Coding',
      readTime: '6 min read',
      date: 'Mar 10, 2025',
      image: null
    },
    {
      id: 4,
      title: 'OB/GYN Medical Billing Guidelines Explained',
      excerpt: 'There are numerous practices that face difficulties with OB/GYN billing, as it involves many responsibilities...',
      category: 'Billing Guidelines',
      readTime: '8 min read',
      date: 'Mar 8, 2025',
      image: null
    },
    {
      id: 5,
      title: 'Essential KPIs Every Medical Practice Should Track',
      excerpt: 'We all know that running a successful medical practice is more than just seeing your patients. But we also need to...',
      category: 'KPIs',
      readTime: '6 min read',
      date: 'Mar 5, 2025',
      image: null
    },
    {
      id: 6,
      title: 'Chiropractic Billing Challenges and Solutions',
      excerpt: 'Did you know that a high proportion of chiropractic claims in the United States have been delayed...',
      category: 'Billing Guidelines',
      readTime: '5 min read',
      date: 'Mar 3, 2025',
      image: null
    },
    {
      id: 7,
      title: 'Denied vs Rejected Claims: What\'s the Difference',
      excerpt: 'Medical billing is a complicated process, especially when dealing with denied vs rejected claims. Both...',
      category: 'Denial Management',
      readTime: '4 min read',
      date: 'Feb 28, 2025',
      image: null
    },
    {
      id: 8,
      title: 'Step-by-Step Denial Management Workbook in Medical Billing',
      excerpt: 'Managing the denial management workflow in medical billing is a very important part that ensures healthcare providers get...',
      category: 'Denial Management',
      readTime: '10 min read',
      date: 'Feb 25, 2025',
      image: null
    },
    {
      id: 9,
      title: 'Key Benefits of Outsourcing Behavioral Health Billing Services',
      excerpt: 'Have you noticed that behavioral health providers lose a great amount of money every year due to billing...',
      category: 'Outsourcing',
      readTime: '6 min read',
      date: 'Feb 22, 2025',
      image: null
    },
    {
      id: 10,
      title: 'What Is Modifier 51 and When to Use It in Medical Billing?',
      excerpt: 'In the US, an alarming number of claims are denied not because the service wasn\'t provided, but because...',
      category: 'Coding',
      readTime: '5 min read',
      date: 'Feb 20, 2025',
      image: null
    },
    {
      id: 11,
      title: '97330 CPT Code: Complete Guide for Healthcare Providers',
      excerpt: 'Do you know that wrong coding of therapy is among the leading causes of claim denials in our nation?',
      category: 'Coding',
      readTime: '7 min read',
      date: 'Feb 18, 2025',
      image: null
    },
    {
      id: 12,
      title: 'CPT Code For Colonoscopy: Essential Billing Guide',
      excerpt: 'Did you know that colorectal cancer is the second leading cause of death related to cancer?',
      category: 'Coding',
      readTime: '6 min read',
      date: 'Feb 15, 2025',
      image: null
    }
  ];

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <main className="blog-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">Blog</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <div className="blog-hero-content">
            <h1 className="blog-hero-title">Medical Billing and Coding Blogs</h1>
            <p className="blog-hero-description">
              Stay updated with the latest trends, guidelines, and insights in medical billing and coding.
              Expert articles to help you maximize revenue and reduce denials.
            </p>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="blog-search-section">
        <div className="container">
          <div className="search-filter-wrapper">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Search articles..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon">🔍</span>
            </div>
            <div className="filter-tabs">
              {categories.map(category => (
                <button 
                  key={category}
                  className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Grid Section */}
      <section className="blog-grid-section">
        <div className="container">
          {filteredPosts.length === 0 ? (
            <div className="no-results">
              <h3>No articles found</h3>
              <p>Try adjusting your search or filter to find what you're looking for.</p>
            </div>
          ) : (
            <div className="blog-grid">
              {filteredPosts.map(post => (
                <article className="blog-card" key={post.id}>
                  <div className="blog-card-content">
                    <div className="blog-category">{post.category}</div>
                    <h2 className="blog-title">{post.title}</h2>
                    <p className="blog-excerpt">{post.excerpt}</p>
                    <div className="blog-meta">
                      <span className="blog-date">{post.date}</span>
                      <span className="blog-read-time">{post.readTime}</span>
                    </div>
                    <button className="read-more-btn">READ MORE →</button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="blog-newsletter">
        <div className="container">
          <div className="newsletter-content">
            <h2>Subscribe to Our Newsletter</h2>
            <p>Get the latest medical billing insights and updates delivered directly to your inbox.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Enter your email address" required />
              <button type="submit">Subscribe →</button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Blog;